export function Skeleton({ width = "100%", height = 12, radius }: { width?: number | string; height?: number; radius?: number }): React.JSX.Element {
  return <span className="nb-skel" style={{ width, height, borderRadius: radius }} aria-hidden="true" />;
}
